import { Box, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { RevealView, StaggerItemView, StaggerView } from '../../common/motion';
import IntroAdvantageCard from './IntroAdvantageCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroAdvantageSection = function IntroAdvantageSection() {
  /**
   * watch
   */
  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var advantageTitle = useWatch({
    control: control,
    name: 'advantageTitle'
  });
  var advantageItems = useWatch({
    control: control,
    name: 'advantageItems'
  });
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col items-center space-y-12 py-16 md:py-24",
    children: [/*#__PURE__*/_jsx(RevealView, {
      className: "text-center",
      children: /*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "font-['Playfair_Display',serif] text-3xl font-bold leading-tight text-[#202020] md:text-[44px]",
        children: advantageTitle
      })
    }), /*#__PURE__*/_jsx(StaggerView, {
      className: "grid w-full grid-cols-1 gap-6 md:grid-cols-2",
      stagger: 0.12,
      children: advantageItems.map(function (item, index) {
        return /*#__PURE__*/_jsx(StaggerItemView, {
          distance: 28,
          children: /*#__PURE__*/_jsx(IntroAdvantageCard, {
            item: item,
            index: index
          })
        }, item.title);
      })
    })]
  });
};

export default IntroAdvantageSection;